import React, { useEffect, useState } from 'react';
import FilterDropdown from '../../../components/Filter/components/FilterDropdown';
import { translate } from '../../../services/translate';
import { dispatchService } from '../../../services/central-api/dispatch';
import { StyleProp, TextStyle } from 'react-native';

interface Props {
    value: number[];
    setValue: (value: number[]) => void;
    actingBodyId: number | null;
    disabled: boolean;
    zIndex: number;
    selectableAgents: { label: string; value: number; }[];
    setSelectableAgents: React.Dispatch<React.SetStateAction<{ label: string; value: number; }[]>>;
    forceUpdate: () => void;
    labelStyle?: StyleProp<TextStyle>;
    viewStyle?: StyleProp<TextStyle>;
}

function AgentsDropdown({ value, setValue, actingBodyId, disabled, zIndex, selectableAgents, setSelectableAgents, forceUpdate, labelStyle, viewStyle }: Props) {
    const [selectedAgent, setSelectedAgent] = useState<number>(0);
    async function getAgents({ actingBodyId }: { actingBodyId: number; }) {
        try {
            const agents = await dispatchService.getAgents({ actingBodyId });
            setSelectableAgents(agents.map((item) => {
                return {
                    label: `${item.name}${item.warName ? ' - ' + item.warName : ''}${item?.role?.name ? ' - ' + item.role.name : ''}: ${item.registry}`,
                    value: item.id
                };
            }));
        } catch (err) {
            console.error(err);
        }
    }

    useEffect(() => {
        if (actingBodyId) {
            getAgents({ actingBodyId });
        }
    }, [actingBodyId]);

    useEffect(() => {
        if (selectedAgent !== 0) {
            setValue([...value, selectedAgent]);
            forceUpdate();
        }
    }, [selectedAgent]);

    return (
        <FilterDropdown
            label={translate('agents')}
            items={selectableAgents.filter(item => !value.includes(item.value))}
            multiple={false}
            setValue={setSelectedAgent}
            value={0}
            disabled={disabled}
            zIndex={zIndex}
            onOpen={() => setSelectedAgent(0)}
            labelStyle={labelStyle}
            viewStyle={viewStyle}
        />
    );
}

export default AgentsDropdown;
